import React from "react";
import CatalogItemsPage from "./CatalogItemsPage";
import olreadiaService from "services/olreadiaService";

export default function ProfessionalSkillsPage() {
  return (
    <CatalogItemsPage
      title="Skills"
      subtitle="Create and manage professional skills used by job opportunities."
      icon="wrench"
      newLabel="New Skill"
      itemLabel="Skill"
      showDelete={false}
      codeReadOnly
      loadItems={() => olreadiaService.professionalSkills.list()}
      getItem={(record) => olreadiaService.professionalSkills.get(record.id)}
      createItem={(payload) => olreadiaService.professionalSkills.create(payload)}
      updateItem={(record, payload) => olreadiaService.professionalSkills.update(record.code, payload)}
      normalizeSearch={(item) => `${item?.code || ""} ${item?.name || ""} ${item?.description || ""}`}
    />
  );
}

